import React, { useEffect, useState } from "react";
import BP from "../../assets/images/bloodpressure.png";
import Temp from "../../assets/images/temp.png";
import HR from "../../assets/images/heart.png";
import PO from "../../assets/images/pulserate.png";
import RR from "../../assets/images/Svg/oxygen.svg";
import Height from "../../assets/images/Svg/height.svg";
import Weight from "../../assets/images/Svg/weight.svg";
import BMI from "../../assets/images/bmi.png";
import VitalService from "../../Services/VitalService";
import dayjs from "dayjs";
import { HSdecrypt } from "../../utils/encryptPassword";

function Vitals(props) {
  const [vitalsData, setVitalsData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  useEffect(() => {
    vitalalldata();
  }, [props.selectedPatient]);

  const vitalalldata = async (value) => {
    let payload = {
      patientId: props.selectedPatient,
      status: 1,
    };
    await VitalService.HSgetVitalDateTime(payload)
      .then((result) => {
        const decryptedData = JSON.parse(HSdecrypt(result.data.data));
        if (decryptedData && decryptedData.length > 0) {
          const defaultDate = decryptedData[0]?.recordedDateTime;
          setSelectedDate(defaultDate);
          MyVitalList(defaultDate);
        } else {
          setVitalsData([]);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch reports:", error);
      });
  };

  const MyVitalList = (values) => {
    let payload = {
      patientId: props.selectedPatient,
      fromDate: values,
      toDate: values,
    };
    VitalService.HSgetVitalsData(payload)
      .then((result) => {
        const decryptedData = JSON.parse(HSdecrypt(result.data.data));
        setVitalsData(decryptedData);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div
      className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
      id="unquie-scroll"
    >
      <div className="flex justify-between items-center p-3">
        <h3 className="text-sm font-bold text-gray-700">Vitals</h3>
        <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
          {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
        </div>
      </div>
      <hr />
      <div className="h-60 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
        <div className="">
          <div className="flex gap-2">
            <div className="flex gap-3">
              <img src={BP} alt="" className="w-5 h-5" />
              <p className="font-semibold text-sm">Blood Pressure:</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">
              {
                vitalsData.filter((vital) => vital.vitalCode === "BPS")[0]
                  ?.value
              }
              /
              {
                vitalsData.filter((vital) => vital.vitalCode === "BPD")[0]
                  ?.value
              }{" "}
              <span>mmHg</span>
            </p>
          </div>
          <div className="flex gap-2">
            <div className="flex gap-3">
              <img src={Temp} alt="" className="w-5 h-5" />
              <p className="font-semibold text-sm">Temperature:</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">
              {vitalsData.filter((vital) => vital.vitalCode === "TP")[0]?.value}
              {"  "}
              <span>°F</span>
            </p>
          </div>
          <div className="flex gap-2">
            <div className="flex gap-3">
              <img src={HR} alt="" className="w-5 h-5" />
              <p className="font-semibold text-sm">Heart Rate:</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">
              {vitalsData.filter((vital) => vital.vitalCode === "HR")[0]?.value}{" "}
              <span>Beats/min</span>
            </p>
          </div>
          <div className="flex gap-2">
            <div className="flex gap-3">
              <img src={PO} alt="" className="w-5 h-5" />
              <p className="font-semibold text-sm">Pulse Oxygen:</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">
              {vitalsData.filter((vital) => vital.vitalCode === "PO")[0]?.value}{" "}
              <span>%</span>
            </p>
          </div>
          <div className="flex gap-2">
            <div className="flex gap-3">
              <img src={RR} alt="" className="w-5 h-5" />
              <p className="font-semibold text-sm">Respiration Rate:</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">
              {vitalsData.filter((vital) => vital.vitalCode === "RR")[0]?.value}{" "}
              <span>Beats/min</span>
            </p>
          </div>
          <p className="font-bold text-base mt-2">Anthropometry</p>
          <div className="flex gap-2">
            <div className="flex gap-3">
              <img src={Height} alt="" className="w-5 h-5" />
              <p className="font-semibold text-sm">Height:</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">
              {vitalsData.filter((vital) => vital.vitalCode === "HI")[0]?.value}{" "}
              <span>cm</span>
            </p>
          </div>
          <div className="flex gap-2">
            <div className="flex gap-3">
              <img src={Weight} alt="" className="w-5 h-5" />
              <p className="font-semibold text-sm">Weight:</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">
              {vitalsData.filter((vital) => vital.vitalCode === "WE")[0]?.value}{" "}
              <span>Kg</span>
            </p>
          </div>
          <div className="flex gap-2">
            <div className="flex gap-3">
              <img src={BMI} alt="" className="w-5 h-5" />
              <p className="font-semibold text-sm">BMI:</p>
            </div>
            <p className="font-medium text-gray-500 text-sm">
              {
                vitalsData.filter((vital) => vital.vitalCode === "BMI")[0]
                  ?.value
              }{" "}
              <span>Kg/m&sup2;</span>
            </p>
          </div>
          <div className="ml-auto font-medium mt-2 flex justify-end">
            <h5 className="text-gray-500 font-semibold text-sm">
              Onset date:{" "}
              <span>{dayjs(selectedDate).format("YYYY-MM-DD")}</span>
            </h5>
          </div>
        </div>
      </div>
    </div>
    // <div className="w-full max-w-[370px] h-[300px] sm:h-[340px] md:h-[370px] md:m-5 border rounded-lg">
    //   <div className="header h-[13%] bg-secondaryColor flex items-center justify-center rounded p-2">
    //     <h1 className="font-bold text-normal text-white mt-3">Vitals</h1>
    //   </div>
    //   <div className="body h-[75%] overflow-y-auto bg-white scrollwidth border-t-2">
    //     <div className="border rounded-md m-3 p-2">
    //       <div className="flex gap-2">
    //         <div className="flex gap-3">
    //           <img src={BP} alt="" className="w-5 h-5" />
    //           <p className="font-semibold text-sm">Blood Pressure:</p>
    //         </div>
    //         <p className="font-medium text-gray-500 text-sm">
    //           {
    //             vitalsData.filter((vital) => vital.vitalCode === "BPS")[0]
    //               ?.value
    //           }
    //           /
    //           {
    //             vitalsData.filter((vital) => vital.vitalCode === "BPD")[0]
    //               ?.value
    //           }{" "}
    //           <span>mmHg</span>
    //         </p>
    //       </div>
    //       <div className="flex gap-2">
    //         <div className="flex gap-3">
    //           <img src={Temp} alt="" className="w-5 h-5" />
    //           <p className="font-semibold text-sm">Temperature:</p>
    //         </div>
    //         <p className="font-medium text-gray-500 text-sm">
    //           {vitalsData.filter((vital) => vital.vitalCode === "TP")[0]?.value}
    //           {"  "}
    //           <span>°F</span>
    //         </p>
    //       </div>
    //       <div className="flex gap-2">
    //         <div className="flex gap-3">
    //           <img src={HR} alt="" className="w-5 h-5" />
    //           <p className="font-semibold text-sm">Heart Rate:</p>
    //         </div>
    //         <p className="font-medium text-gray-500 text-sm">
    //           {vitalsData.filter((vital) => vital.vitalCode === "HR")[0]?.value}{" "}
    //           <span>Beats/min</span>
    //         </p>
    //       </div>
    //       <div className="flex gap-2">
    //         <div className="flex gap-3">
    //           <img src={PO} alt="" className="w-5 h-5" />
    //           <p className="font-semibold text-sm">Pulse Oxygen:</p>
    //         </div>
    //         <p className="font-medium text-gray-500 text-sm">
    //           {vitalsData.filter((vital) => vital.vitalCode === "PO")[0]?.value}{" "}
    //           <span>%</span>
    //         </p>
    //       </div>
    //       <div className="flex gap-2">
    //         <div className="flex gap-3">
    //           <img src={RR} alt="" className="w-5 h-5" />
    //           <p className="font-semibold text-sm">Respiration Rate:</p>
    //         </div>
    //         <p className="font-medium text-gray-500 text-sm">
    //           {vitalsData.filter((vital) => vital.vitalCode === "RR")[0]?.value}{" "}
    //           <span>Beats/min</span>
    //         </p>
    //       </div>
    //       <p className="font-bold text-base">Anthropometry</p>
    //       <div className="flex gap-2">
    //         <div className="flex gap-3">
    //           <img src={Height} alt="" className="w-5 h-5" />
    //           <p className="font-semibold text-sm">Height:</p>
    //         </div>
    //         <p className="font-medium text-gray-500 text-sm">
    //           {vitalsData.filter((vital) => vital.vitalCode === "HI")[0]?.value}{" "}
    //           <span>cm</span>
    //         </p>
    //       </div>
    //       <div className="flex gap-2">
    //         <div className="flex gap-3">
    //           <img src={Weight} alt="" className="w-5 h-5" />
    //           <p className="font-semibold text-sm">Weight:</p>
    //         </div>
    //         <p className="font-medium text-gray-500 text-sm">
    //           {vitalsData.filter((vital) => vital.vitalCode === "WE")[0]?.value}{" "}
    //           <span>Kg</span>
    //         </p>
    //       </div>
    //       <div className="flex gap-2">
    //         <div className="flex gap-3">
    //           <img src={BMI} alt="" className="w-5 h-5" />
    //           <p className="font-semibold text-sm">BMI:</p>
    //         </div>
    //         <p className="font-medium text-gray-500 text-sm">
    //           {
    //             vitalsData.filter((vital) => vital.vitalCode === "BMI")[0]
    //               ?.value
    //           }{" "}
    //           <span>Kg/m&sup2;</span>
    //         </p>
    //       </div>
    //       <div className="ml-auto font-medium mt-2 flex justify-end">
    //         <h5 className="text-gray-500 font-semibold text-sm">
    //           Onset date:{" "}
    //           <span>{dayjs(selectedDate).format("YYYY-MM-DD")}</span>
    //         </h5>
    //       </div>
    //     </div>
    //   </div>
    //   <div className="footer h-[44px] bg-secondaryColor rounded"></div>
    // </div>
  );
}

export default Vitals;
